// == Import npm
import React from "react";
import { Button, Modal, Typography } from "antd";

// == Import SCSS
import "./modalConfirm.less";
import { useTranslation } from "react-i18next";

// == Import icons

const ModalConfirm = ({
  isVisible,
  title = "",
  question = "",
  onConfirm = () => {},
  onCancel = () => {},
  okOnly = false,
}) => {
  const handleOk = () => {
    onConfirm();
  };

  const handleCancel = () => {
    onCancel();
  };

  const [t] = useTranslation();

  return (
    <Modal
      width="700px"
      open={isVisible}
      onOk={handleOk}
      onCancel={handleCancel}
      footer={
        <>
          {!okOnly && (
            <Button
              style={{ width: "150px" }}
              type="default"
              size="large"
              className="modalDelete__modal__no"
              onClick={handleCancel}
            >
              {t("No")}
            </Button>
          )}
          <Button
            type="primary"
            style={{ width: "150px" }}
            size="large"
            className="modalDelete__modal__yes"
            onClick={handleOk}
          >
            {okOnly ? t("Close") : t("Yes")}
          </Button>
        </>
      }
      bodyStyle={{ padding: "48px 30px 24px 30px" }}
      className="modalConfirm"
    >
      <Typography.Title level={3} style={{ textAlign: "center" }}>
        {title}
      </Typography.Title>
      <Typography.Text
        style={{
          marginTop: "25px",
          textAlign: "center",
          fontSize: "24px",
        }}
      >
        {question}
      </Typography.Text>
    </Modal>
  );
};

export default ModalConfirm;
